<template>
  <q-layout id="dashboard" view="hHh LpR lFr">
    <Header @toggle="isSidebarOpen = !isSidebarOpen" />
    <q-drawer
      id="sidebar"
      v-model="isSidebarOpen"
      show-if-above
      side="left"
      content-style="background-color: #1c2b36"
      :width="260"
      :mini="isSidebarCollapsed"
    >
      <q-scroll-area
        class="fit"
        :content-style="{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }"
      >
        <q-list>
          <q-item
            class="text-grey-4 q-py-lg"
            :clickable="$q.screen.gt.sm"
            @click="isSidebarCollapsed = !isSidebarCollapsed"
            @mouseover="isArrowShown = true"
            @mouseout="isArrowShown = false"
          >
            <q-item-section avatar>
              <q-icon size="md" name="menu" color="muted" />
            </q-item-section>

            <q-item-section>
              <h5>Dashboard</h5>
            </q-item-section>

            <q-item-section v-show="isArrowShown" avatar>
              <q-icon name="arrow_back" size="xs" color="primary">
                <q-tooltip anchor="bottom right" self="bottom left"> Minimize </q-tooltip>
              </q-icon>
            </q-item-section>
          </q-item>

          <sidebar :is-title-shown="!isSidebarCollapsed" />
        </q-list>

        <q-item>
          <q-btn
            v-if="!isSidebarCollapsed"
            class="full-width"
            color="primary"
            label="Logout"
            icon="power_settings_new"
            @click="handleLogout"
          >
            <q-tooltip anchor="center right" self="center left">Logout</q-tooltip>
          </q-btn>

          <q-btn v-else class="full-width" flat color="primary" icon="power_settings_new" @click="handleLogout">
            <q-tooltip anchor="center right" self="center left">Logout</q-tooltip>
          </q-btn>
        </q-item>
      </q-scroll-area>
    </q-drawer>

    <q-page-container>
      <div class="q-px-sm q-pb-sm">
        <router-view />
      </div>
    </q-page-container>
  </q-layout>
</template>

<script>
import get from 'lodash/get';
import { mapFields } from 'vuex-map-fields';
import { mapActions } from 'vuex';
import Header from '@/components/Header.vue';

export default {
  name: 'Dashboard',

  components: {
    Header,
    Sidebar: () => import('@/components/Sidebar/Index.vue'),
  },

  props: {
    new: {
      type: Boolean,
      required: false,
    },
  },

  data() {
    return {
      isSidebarOpen: false,
      isSidebarCollapsed: false,
      isArrowShown: false,
      step: 1,
    };
  },

  computed: {
    ...mapFields(['user']),
    sideBarClass() {
      return {
        'sidebar--collapsed': this.isSidebarCollapsed,
      };
    },
    mainClass() {
      return {
        'main--sidebar-collapsed': this.isSidebarCollapsed,
      };
    },
    isVerified() {
      return get(this.user, 'isVerified', false);
    },
  },

  methods: {
    ...mapActions(['logout']),
    async handleLogout() {
      await this.logout();
      return this.$router.push('/login');
    },
  },
};
</script>

<style lang="stylus">
@import '~quasar-variables';

#sidebar {
  .item {
    color: white !important;

    svg, i {
      color: #6c757d;
    }

    &-active {
      color: $primary !important;
      background-color: white;
      border-radius: 6px 0 0 6px;

      svg, i {
        color: $primary;
      }
    }
  }

  .title {
    background-color: #24333d;
  }
}
</style>
